import React, { useEffect, useState } from "react";
import './change-password.css';
import { useLoaderData, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AxiosResponse } from "axios";
import { showDefaultErrorMessages } from "../../../../../utils/show-default-error-message/show-default-error-messages";
import { AlertMessageState, clearAlertMessage, showAlertMessage } from "../../../../../redux/reducer/alert-message.reducer";
import { DefaultErrorResponse } from "../../../../../types/api/error/default-error-response/default-error-respose.type";
import { showLoadingAlertMessage } from "../../../../../utils/show-loading-alert-message/show-loading-alert-message";
import { networkCall } from "../../../../../utils/network-call/network-call";
import { AlertMessages } from "../../../../../enums/alert-messages.enum";
import { ValidationErrorResponseData } from "../../../../../types/api/error/validation-error-response-data/validation-error-response-data.type.";
import { PasswordInput } from "../../../../../components/field/password-input/password-input";
import { getImageUrl } from "../../../../../utils/image-helper/get-image-url";

export const ChangePassword = () => {
    const [formValues, setFormValues] = useState({
        password: {
            value: '',
            error: ''
        },
        passwordAgain: {
            value: '',
            error: ''
        }
    });
    const loaderData: any = useLoaderData();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const messageShowed = showDefaultErrorMessages(loaderData.checkPasswordResetTokenResponse);
        if(messageShowed) {
            navigate('/cms/login');
            return;
        };

        dispatch(clearAlertMessage());
        const alertMessageState: AlertMessageState = {
            alertMessageType: 'error',
            alertMessageText: 'Ismeretlen hiba történt. Kérjük próbálja újra!'
        };

        if (loaderData.checkPasswordResetTokenResponse.status === 200) return;

        if (loaderData.checkPasswordResetTokenResponse.status === 404) {
            const res: AxiosResponse<DefaultErrorResponse> = loaderData.checkPasswordResetTokenResponse;

            switch (res.data.code) {
                case 8000:
                    alertMessageState.alertMessageText = 'A jelszó módosításának határideje lejárt vagy rosszul másolta be a böngésző címsorába a linket.';
            }
        }
        
        dispatch(showAlertMessage(alertMessageState));

        navigate('/cms/login');
    }, [loaderData, dispatch, navigate]);

    const handleChange = (name: keyof typeof formValues, value: string) => {
        const newFormValues: typeof formValues = JSON.parse(JSON.stringify(formValues));
        newFormValues[name].error = '';
        newFormValues[name].value = value;
        setFormValues(newFormValues);
    };

    const validateForm = () => {
        let valid = true;
        const newFormValues: typeof formValues = JSON.parse(JSON.stringify(formValues));
        newFormValues.password.error = '';
        newFormValues.passwordAgain.error = '';

        if (!formValues.password.value) {
            valid = false;
            newFormValues.password.error = 'Mező kitöltése kötelező';
        }

        if (!formValues.passwordAgain.value) {
            valid = false;
            newFormValues.passwordAgain.error = 'Mező kitöltése kötelező';
        }

        if (!valid) {
            setFormValues(newFormValues);
            return false;
        }

        if (formValues.password.value.length < 8) {
            newFormValues.password.error = 'Legalább 8 karakternek kell lennie.';
            setFormValues(newFormValues);
            return false;
        }

        if (formValues.password.value !== formValues.passwordAgain.value) {
            newFormValues.password.error = 'A jelszavak nem egyeznek meg.';
            newFormValues.passwordAgain.error = 'A jelszavak nem egyeznek meg.';
            setFormValues(newFormValues);
            return false;
        }

        return true;
    };

    const handleChangePasswordButtonClick = async () => {
        if (!validateForm()) return;

        showLoadingAlertMessage();

        const response = await networkCall('/users/change-password', {
            method: 'POST',
            body: {
                password: formValues.password.value,
                token: loaderData.token
            }
        });

        const messageShowed = showDefaultErrorMessages(response);
        if(messageShowed) return;

        dispatch(clearAlertMessage());
        const alertMessageState: AlertMessageState = {
            alertMessageType: 'error',
            alertMessageText: AlertMessages.UnknownErrorTryAgain
        };

        if (response?.status === 200) {
            alertMessageState.alertMessageType = 'success';
            alertMessageState.alertMessageText = 'Jelszava sikeresen megváltozott.'
            navigate('/cms/login');
        } else if (response?.status === 404) {
            const res: AxiosResponse<DefaultErrorResponse> = response;

            switch (res.data.code) {
                case 8000:
                    alertMessageState.alertMessageText = 'A jelszó módosításának határideje lejárt vagy rosszul másolta be a böngésző címsorába a linket.';
            }
        } else if (response?.status === 400) {
            const _res: AxiosResponse<DefaultErrorResponse> = response;

            switch (_res.data.code) {
                case 1000:
                    const res: AxiosResponse<DefaultErrorResponse<ValidationErrorResponseData[]>> = response;
                    alertMessageState.alertMessageText = 'HibáSan megadott beviteli mezők.';
                    if (res.data.data) {
                        const newFormValues = JSON.parse(JSON.stringify(formValues));
                        for (const element of res.data.data) {
                            if (element.field === 'password') newFormValues.password.error = element.errors.join(', ');
                        }
                        setFormValues(newFormValues);
                    }
                    break;
            }
        }

        dispatch(showAlertMessage(alertMessageState));
    };

    return (
        <div className="change-password-container">
            <div className="title">Jelszó megváltoztatása</div>
            <div className="body">
                <PasswordInput
                    id="password"
                    name="password"
                    value={formValues.password.value}
                    onChange={(value) => handleChange('password', value)}
                    placeholder="jelszó"
                    icon={getImageUrl('password-icon.png')}
                    error={formValues.password.error}
                />
                <div style={{ height: '25px' }}/>
                <PasswordInput
                    id="passwordAgain"
                    name="passwordAgain"
                    value={formValues.passwordAgain.value}
                    onChange={(value) => handleChange('passwordAgain', value)}
                    placeholder="jelszó újra"
                    icon={getImageUrl('password-icon.png')}
                    error={formValues.passwordAgain.error}
                />

                <button className="change-password-btn" onClick={handleChangePasswordButtonClick}>
                    Változtat
                </button>
            </div>
        </div>
    );
};